<kt-base-modal [title]="'Acknowledged By'" [showFooter]="true">
  <div modal-body>
    <kt-loader [showLoader]="loading()">
      <div class="kt-widget4 py-3">
        <div class="kt-widget4__item" *ngFor="let user of acknowledgedByList">
          <div class="kt-widget4__pic kt-widget4__pic--pic">
            <span class="kt-media kt-media--circle">

              <img *ngIf="user?.user_business?.user_business_profile_image_url"
                [src]="user?.user_business?.user_business_profile_image_url" alt="">
            </span>
            <span *ngIf="!user?.user_business?.user_business_profile_image_url"
              class="kt-badge kt-badge--md kt-badge--rounded kt-badge--bold kt-badge--username">
              <span>{{(user?.user_business?.user_business_first_name?.toUpperCase() + ' ' +
                user?.user_business?.user_business_last_name?.toUpperCase() ) | firstLetter}}</span>
            </span>
          </div>
          <div class="kt-widget4__info">
            <span class="kt-widget4__username text-dark">
              {{user?.user_business?.user_business_first_name}} {{user?.user_business?.user_business_last_name}}
              <small>{{user?.user_business?.user_business_archive ? '(Archived)' : '' }} </small>
              <span>
                <kt-invited-icon [inviteValue]="user?.user_business?.user_business_status">
                </kt-invited-icon>
              </span>
            </span>

            <div>
              <kt-role-badge [role_name]="user?.user_business?.user_role"
                [associate]="user?.user_business?.user_role_associate"></kt-role-badge>
              <!-- {{user?.user_business?.user_role}} -->
            </div>
          </div>
        </div>
      </div>
    </kt-loader>
  </div>
  <div modal-footer>
    <button class="btn btn-brand" (click)="activeModal.close()">Close</button>
  </div>
</kt-base-modal>
